import { LovValueSummary } from "../../../../../common/lov/lov-value/api/model/lovValueSummary.model";
import { Moment } from "moment";
import { PlainDtoModel } from "../../../../../common/entity/dto/plain/plainDto.model";

export class WorkflowTaskTriggerModel implements PlainDtoModel {

    type: LovValueSummary;
    time: Moment;

}

export enum WorkflowTaskTriggerType {
    WORKFLOW_TASK_TRIGGER_MANUAL = 'WORKFLOW_TASK_TRIGGER_MANUAL',
    WORKFLOW_TASK_TRIGGER_DATETIME = 'WORKFLOW_TASK_TRIGGER_DATETIME',
    WORKFLOW_TASK_TRIGGER_IMMEDIATE = 'WORKFLOW_TASK_TRIGGER_IMMEDIATE'
}
